import { MessageBroadcastChannel } from '../../message-type/message-broadcast-channel';
import { ILogoutMessageType } from './logout-message.interface';
var name = 'docMessageCenterChannel';
var LogOutMessageEntity = /** @class */ (function () {
    function LogOutMessageEntity() {
        this.logoutMessage = new MessageBroadcastChannel(name, this.logoutMessageCheckFn);
        this.key = "".concat(Math.floor(Math.random() * 1000000000), "_").concat(+new Date());
    }
    LogOutMessageEntity.prototype.connect = function () {
        this.logoutMessage.connect();
    };
    LogOutMessageEntity.prototype.getLogoutMessage = function (listener) {
        this.logoutMessage.receive(listener);
    };
    LogOutMessageEntity.prototype.sendLogoutMessage = function (userIndex) {
        this.logoutMessage.send({
            key: this.key,
            type: ILogoutMessageType.LOGOUT,
            userIndex: userIndex,
        });
    };
    LogOutMessageEntity.prototype.logoutMessageCheckFn = function (message) {
        var data = message.data;
        return data.key !== this.key;
    };
    return LogOutMessageEntity;
}());
export { LogOutMessageEntity };
